<div class="product-benefit display-utils-row display-utils-start-center">
  <div class="benefit-icon">
    <img [src]="iconUrl" alt="{{title}}" class="icon" />
  </div>

  <div class="benefit-content">
    <h3 class="benefit-title">{{ title }}</h3>
    <p class="benefit-description">{{ description }}</p>
  </div>
</div>
